<app-dialog-heading [heading]="heading"></app-dialog-heading>
<div mat-dialog-content>
	<form [formGroup]="benefitFormGroup">
		<!--Row-1-->
		<mat-grid-list cols="2" rowHeight="60px">
			<mat-grid-tile>
				<mat-form-field class="w-90">
					<mat-label>Benefit Name</mat-label>
					<input matInput type="text" [formControlName]="controls.Name" required>
				</mat-form-field>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Benefit Name')">help_outline</mat-icon>
			</mat-grid-tile>
			<mat-grid-tile>
				<mat-form-field class="w-90">
					<mat-label>Minimum Age</mat-label>
					<input matInput type="number" [formControlName]="controls.AgeMin">
				</mat-form-field>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Minimum Age')">help_outline</mat-icon>
			</mat-grid-tile>
		</mat-grid-list>
		<!--Row-2-->
		<mat-grid-list cols="2" rowHeight="60px">
			<mat-grid-tile>
				<mat-form-field class="w-90">
					<mat-label>Benefit Code</mat-label>
					<input matInput type="text" [formControlName]="controls.BenefitCode" required>
				</mat-form-field>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Benefit Code')">help_outline</mat-icon>
			</mat-grid-tile>
			<mat-grid-tile>
				<mat-form-field class="w-90">
					<mat-label>Maximum Age</mat-label>
					<input matInput type="number" [formControlName]="controls.AgeMax">
				</mat-form-field>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Maximum Age')">help_outline</mat-icon>
			</mat-grid-tile>
		</mat-grid-list>
		<!--Row-3-->
		<mat-grid-list cols="2" rowHeight="60px">
			<mat-grid-tile>
				<mat-form-field class="w-90">
					<mat-label>Benefit Family</mat-label>
					<mat-select [formControlName]="controls.FamilyOfBenefit"
											data-qa="qa-benefitFamily">
						<mat-option *ngFor="let familyOfBenefit of familyOfBenefitLookupValues" [value]="familyOfBenefit.value">
							{{familyOfBenefit.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Benefit Family')">help_outline</mat-icon>
			</mat-grid-tile>
      <mat-grid-tile>
        <app-element-select class="w-90" displayLabel='Sub-Class'
														 [qaAttr]="'qa-subclass'"
                              [defaultValue]="selectedProcessingSubClass"
                              [options]="processingSubClassValues"
                              [required]="true"
                              (selectionChanged)="onProcessingSubClassSelectionChanged($event)">
        </app-element-select>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Sub-Class')">help_outline</mat-icon>
			</mat-grid-tile>
		</mat-grid-list>
		<!--Row-4-->
		<mat-grid-list cols="2" rowHeight="60px">
			<mat-grid-tile>
				<mat-form-field class="w-90">
					<mat-label>Encounter types</mat-label>
					<mat-select [formControlName]="controls.EncounterType" (selectionChange)="onUpdateEncounterTypesList()"
											data-qa="qa-encounterTypes">
						<mat-option *ngFor="let encounterType of encounterTypeLookupValues" [value]="encounterType.value">
							{{encounterType.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Encounter Type')">help_outline</mat-icon>
			</mat-grid-tile>
			<mat-grid-tile>
				<mat-form-field class="w-90">
					<mat-label>Gender</mat-label>
					<mat-select [formControlName]="controls.Gender" (selectionChange)="onUpdateGendersList()"
										data-qa="qa-gender">
						<mat-option *ngFor="let gender of genderLookupValues" [value]="gender.value">
							{{gender.name}}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Gender')">help_outline</mat-icon>
			</mat-grid-tile>
		</mat-grid-list>
		
		<!---------------------------->
		<!-- Row 5 -->
		<!---------------------------->
		
		<div class="clearfix">
			<div class="md-col md-col-6 pt1 pb2 relative">
				<app-element-slide-toggle [label]="'Benefit Booking'"
																	[formControlName]="controls.BookBenefit">
				</app-element-slide-toggle>
				<mat-icon class="info-icon absolute" [matTooltip]="getInfoTooltip('Benefit Booking')">help_outline</mat-icon>
			</div>
		</div>
		
		<!---------------------------->
		<!-- List Section -->
		<!---------------------------->
		<div style="width: 46%; float: left; margin-left: 10px;">
			<div class="list-section">
				<div class="list-item" *ngFor="let item of encounterTypesList">
					<div class="item-width">
						{{item?.encounterType?.type}}
					</div>
					<div class="trash-icon">
						<mat-icon class="mat-primary-color hand-cursor" matTooltip="DELETE"
											(click)="onDeleteEncounterType(item)">delete
						</mat-icon>
					</div>
				</div>
			</div>
		</div>
		
		<div style="width: 48%; float: right;">
			<div class="list-section">
				<div class="list-item" *ngFor="let item of gendersList">
					<div class="item-width">
						{{item?.gender?.name}}
					</div>
					<div class="trash-icon">
						<mat-icon class="mat-primary-color hand-cursor" matTooltip="DELETE"
											(click)="onDeleteGender(item)">delete
						</mat-icon>
					</div>
				</div>
			</div>
		</div>
		
		
	</form>
	<p style="color: red">{{errorMessage}}</p>
</div>
<mat-dialog-actions align="center">
	<button mat-raised-button [mat-dialog-close]="false" color="warn">Cancel</button>
	<button mat-raised-button color="primary" [disabled]="!benefitFormGroup.valid" (click)="onSaveBenefit()">
		Save
	</button>
</mat-dialog-actions>
